import {Box as MuiBox, BoxProps} from '@mui/material';
import React from 'react';

type PolymorphicBoxProps<C extends React.ElementType = 'div'> = BoxProps<C> & {
  component?: C;
};

const Box = React.forwardRef(function Box<C extends React.ElementType = 'div'>(
  props: PolymorphicBoxProps<C>,
  ref: React.Ref<HTMLElement>,
) {
  return <MuiBox ref={ref} {...props} />;
}) as <C extends React.ElementType = 'div'>(
  props: PolymorphicBoxProps<C> & {ref?: React.Ref<HTMLElement>},
) => React.ReactElement | null;

export default Box;
